var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 23.9997L23.9999 39.9997M23.9999 23.9997L39.9999 39.9997M58.6666 31.9997C58.6666 46.7273 46.7275 58.6663 31.9999 58.6663C17.2723 58.6663 5.33325 46.7273 5.33325 31.9997C5.33325 17.2721 17.2723 5.33301 31.9999 5.33301C46.7275 5.33301 58.6666 17.2721 58.6666 31.9997Z",
    stroke: "#F04438",
    strokeWidth: 5.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.70289bfdf0e1ba619f62a67157044e5b.svg";
export { ForwardRef as ReactComponent };